module.exports = __webpack_public_path__ + "2321a2ec5e5db72d70a6a7850ccfe648.glb";